import { z } from 'zod';

export type GrowthbookEventType = 'Growthbook_FeatureFlagCalled';

const ExperimentResultSchema = z.object({
  variantName: z.string(),
  variationId: z.number(),
  value: z.any(),
  isOn: z.boolean(),
});

export const GrowthbookEventBaseSchema = z.object({
  $feature_flag: z.string(),
  $feature_flag_response: z.union([z.boolean(), z.string(), z.number()]),
  $feature_flag_payloads: ExperimentResultSchema.optional(),
});
export const Growthbook_FeatureFlagCalledPayloadSchema = GrowthbookEventBaseSchema;

export type GrowthbookEventTypePayloadMap = {
  Growthbook_FeatureFlagCalled: z.infer<typeof Growthbook_FeatureFlagCalledPayloadSchema>;
};

export const GrowthbookEventSchemaMap = {
  Growthbook_FeatureFlagCalled: Growthbook_FeatureFlagCalledPayloadSchema,
};
